export default "__VITE_ASSET__DhLclZQF__"